import { ReviewsGroupType, REVIEWS_GROUP_SET } from 'features/reviews';
import {
  getGroupId,
  getIsGroupRatings,
  getReviewGroupSorting,
  getReviewsRatingTotal,
} from 'features/reviews/selectors';
import { Tab } from 'fronton-react';
import React from 'react';
import { Content, tabStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { GROUP_OF_VARIANTS, SINGLE_PRODUCT } from 'common/constants';
import { useTranslation } from 'react-i18next';

export const PdpReviewsGroupTabs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isGroupRatings = useSelector(getIsGroupRatings);

  const defaultActiveTab = useSelector(getReviewGroupSorting);
  const singleReviewCount = useSelector(getReviewsRatingTotal)?.count ?? 0;
  const groupId = useSelector(getGroupId);
  const handleClickTab = (tabId: ReviewsGroupType) => {
    dispatch(REVIEWS_GROUP_SET(tabId));
  };

  if (!groupId || !isGroupRatings) return null;

  return (
    <Content>
      <Tab
        active={defaultActiveTab === GROUP_OF_VARIANTS}
        onClick={() => handleClickTab(GROUP_OF_VARIANTS)}
        size="l"
      >
        {t('reviews.review.tabs.all_reviews')}
      </Tab>
      <Tab
        className={tabStyles}
        active={defaultActiveTab === SINGLE_PRODUCT}
        onClick={() => handleClickTab(SINGLE_PRODUCT)}
        disabled={singleReviewCount === 0}
        size="l"
      >
        {t('reviews.review.tabs.selected_variant')}
      </Tab>
    </Content>
  );
};
